import {
  UPDATE_OTHER_PROJECT,
  UPDATE_OTHER_PROJECT_LIST,
  UPDATE_REC_PROJECT_LIST,
  FETCH_OTHER_PROJECT_LIST,
  FETCH_OTHER_PROJECT_LIST_START,
  FETCH_OTHER_PROJECT_LIST_SUCCESS,
  FETCH_OTHER_PROJECT_LIST_ERROR,
  FETCH_REC_PROJECT_LIST,
  FETCH_REC_PROJECT_LIST_START,
  FETCH_REC_PROJECT_LIST_SUCCESS,
  FETCH_REC_PROJECT_LIST_ERROR,
  POST_NVBUG_PROJECT,
  POST_NVBUG_PROJECT_START,
  POST_NVBUG_PROJECT_SUCCESS,
  POST_NVBUG_PROJECT_ERROR,
  UPDATE_NVBUGS_ID,
  UPDATE_PAGE,
  CLEAR,
  FETCH_NVBUG,
  FETCH_NVBUG_START,
  FETCH_NVBUG_SUCCESS,
  FETCH_NVBUG_ERROR,
  UPDATE_OPTION_SELECTED
} from './constants'

const updateOtherProject = (project) => ({ type: UPDATE_OTHER_PROJECT, project })
const updateOtherProjectList = (projectList) => ({ type: UPDATE_OTHER_PROJECT_LIST, projectList })
const updateRecProjectList = (projectList) => ({ type: UPDATE_REC_PROJECT_LIST, projectList })
const updateOptionSelected = (project) => ({ type: UPDATE_OPTION_SELECTED, project })
const updateNvbugsId = (nvbugId, synopsis) => ({ type: UPDATE_NVBUGS_ID, nvbugId, synopsis })
const fetchOtherProjectList = (query) => ({ type: FETCH_OTHER_PROJECT_LIST, query })
const fetchOtherProjectListStart = () => ({ type: FETCH_OTHER_PROJECT_LIST_START })
const fetchOtherProjectListSuccess = () => ({ type: FETCH_OTHER_PROJECT_LIST_SUCCESS })
const fetchOtherProjectListError = (error) => ({ type: FETCH_OTHER_PROJECT_LIST_ERROR, error })
const fetchRecProjectList = (nvbugId) => ({ type: FETCH_REC_PROJECT_LIST, nvbugId })
const fetchRecProjectListStart = () => ({ type: FETCH_REC_PROJECT_LIST_START })
const fetchRecProjectListSuccess = () => ({ type: FETCH_REC_PROJECT_LIST_SUCCESS })
const fetchRecProjectListError = (error) => ({ type: FETCH_REC_PROJECT_LIST_ERROR, error })
const postNvbugProject = (nvbugId, projectId) => ({ type: POST_NVBUG_PROJECT, nvbugId, projectId })
const postNvbugProjectStart = () => ({ type: POST_NVBUG_PROJECT_START })
const postNvbugProjectSuccess = () => ({ type: POST_NVBUG_PROJECT_SUCCESS })
const postNvbugProjectError = (error) => ({ type: POST_NVBUG_PROJECT_ERROR, error })
const fetchNvbug = (nvbugId) => ({ type: FETCH_NVBUG, nvbugId })
const fetchNvbugStart = () => ({ type: FETCH_NVBUG_START })
const fetchNvbugSuccess = () => ({ type: FETCH_NVBUG_SUCCESS })
const fetchNvbugError = (error) => ({ type: FETCH_NVBUG_ERROR, error })
const updatePage = (page) => ({ type: UPDATE_PAGE, page })
const clear = () => ({ type: CLEAR })

export {
  updateOtherProject,
  updateOtherProjectList,
  updateRecProjectList,
  updateOptionSelected,
  updateNvbugsId,
  fetchOtherProjectList,
  fetchOtherProjectListStart,
  fetchOtherProjectListSuccess,
  fetchOtherProjectListError,
  fetchRecProjectList,
  fetchRecProjectListStart,
  fetchRecProjectListSuccess,
  fetchRecProjectListError,
  postNvbugProject,
  postNvbugProjectStart,
  postNvbugProjectSuccess,
  postNvbugProjectError,
  fetchNvbug,
  fetchNvbugStart,
  fetchNvbugSuccess,
  fetchNvbugError,
  updatePage,
  clear
}
